import { Suspense } from 'react'
import { motion } from 'framer-motion'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuthStore } from '@/features/user-login/useAuthStore.ts'
import { Spinner } from '@/shared/ui/spinner.tsx'

const RouteLoadingFallback = () => (
	<div className='flex min-h-[50vh] items-center justify-center'>
		<Spinner className='h-8 w-8' />
	</div>
)

export const ProtectedRoute = () => {
	const { isAuthenticated, isInitialized } = useAuthStore()
	const location = useLocation()

	if (!isInitialized) return null

	if (!isAuthenticated) return <Navigate to='/login' state={{ from: location }} replace />

	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
			<Suspense fallback={<RouteLoadingFallback />}>
				<Outlet />
			</Suspense>
		</motion.div>
	)
}
